import { Reveal } from "./Reveal";
import {
  TrendingUp,
  Megaphone,
  Share2,
  Sparkles,
  PenTool,
  Compass,
  ArrowUpRight,
} from "lucide-react";

const SERVICES = [
  {
    icon: TrendingUp,
    title: "Digital Marketing",
    desc: "Full-funnel strategy, SEO and performance campaigns that compound into durable growth.",
  },
  {
    icon: Megaphone,
    title: "Online Advertising",
    desc: "Paid media across Google, Meta and programmatic — engineered for return, not vanity metrics.",
  },
  {
    icon: Share2,
    title: "Social Media Management",
    desc: "Always-on community building and content calendars that keep your brand culturally relevant.",
  },
  {
    icon: Sparkles,
    title: "Branding",
    desc: "Identity, positioning and visual systems that make your brand impossible to ignore.",
  },
  {
    icon: PenTool,
    title: "Content Strategy",
    desc: "Editorial planning and production — from thought leadership to conversion-ready copy.",
  },
  {
    icon: Compass,
    title: "Business Consulting",
    desc: "Go-to-market advisory and operational clarity for founders scaling into new markets.",
  },
];

export default function Services() {
  return (
    <section id="services" className="py-24 md:py-32 border-b border-white/10">
      <div className="max-w-[1400px] mx-auto px-4 md:px-8">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-14">
          <Reveal>
            <p className="text-xs tracking-[0.35em] uppercase text-accent mb-6">What we do</p>
            <h2 className="font-display text-4xl md:text-5xl lg:text-6xl tracking-tight max-w-2xl leading-[1.02]">
              Services built to move the needle.
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="text-muted-foreground max-w-xs text-sm md:text-base">
              Six disciplines, one integrated team — no silos, no hand-offs, just results.
            </p>
          </Reveal>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 border-t border-l border-white/10">
          {SERVICES.map((s, i) => {
            const Icon = s.icon;
            return (
              <Reveal key={s.title} delay={(i % 3) * 0.08}>
                <div
                  data-testid={`service-card-${i}`}
                  className="group relative border-b border-r border-white/10 p-8 md:p-10 h-full min-h-[260px] flex flex-col justify-between transition-colors duration-500 hover:bg-white/[0.03]"
                >
                  <div className="flex items-start justify-between">
                    <Icon className="text-accent" size={30} strokeWidth={1.4} />
                    <span className="font-display text-lg text-muted-foreground">
                      0{i + 1}
                    </span>
                  </div>
                  <div>
                    <h3 className="font-display text-2xl md:text-3xl mb-3 flex items-center gap-2">
                      {s.title}
                      <ArrowUpRight
                        size={20}
                        className="text-accent opacity-0 -translate-x-2 transition-all duration-300 group-hover:opacity-100 group-hover:translate-x-0"
                      />
                    </h3>
                    <p className="text-sm text-muted-foreground leading-relaxed">{s.desc}</p>
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
